import styled from 'styled-components';

import { Portal } from '@dreryk/react-components';

export const StyledVisitHeaderActionsContainer = styled(Portal.Container)`
   display: flex;
   align-items: center;
   gap: 12px;
`;

StyledVisitHeaderActionsContainer.displayName = 'StyledVisitHeaderActionsContainer';
